import React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-solid-svg-icons";

// Define keyframes for the beat (pulse) animation.
const beatAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

// Create a styled-component wrapper for FontAwesomeIcon.
const AnimatedIconWrapper = styled(FontAwesomeIcon)`
  animation: ${beatAnimation} ${(props) => props.beatDuration || "1s"} linear
    infinite;
  color: ${(props) => props.color || "#3498db"};
  font-size: ${(props) => props.size || "24px"};
`;

// Reusable AnimatedIcon component
const AnimatedIcon = ({ icon, color, size, beatDuration, ...rest }) => {
  return (
    <AnimatedIconWrapper
      icon={icon}
      color={color}
      size={size}
      beatDuration={beatDuration}
      {...rest}
    />
  );
};

AnimatedIcon.propTypes = {
  icon: PropTypes.object, // FontAwesome icon definition
  color: PropTypes.string, // Color of the icon
  size: PropTypes.string, // Font size (e.g. "24px")
  beatDuration: PropTypes.string, // Duration of the animation cycle (e.g. "1s")
};

AnimatedIcon.defaultProps = {
  icon: faImage,
  color: "#3498db",
  size: "24px",
  beatDuration: "1s",
};

export default AnimatedIcon;